export default __webpack_public_path__ + "static/media/MaskGroup349.e90fc51f.png";